import { Textarea } from "@/components/ui/textarea"
import { AlternativesComponent } from '@src/components/textarea/Alternatives.tsx';
import { useAtom } from 'jotai';
import { getSubmenuStateAtom } from '@src/atoms';
import { Icon } from '@src/components/icon/Icon';
import { useState } from 'react';

export interface TextareaProps {
  value?: string,
  onValueChange?: (value: string, extraOpts?: Record<string, unknown>) => void,
  placeholder?: string,
  className?: string,
  alternatives?: string[],
  withAlternatives?: boolean,
  disabled?: boolean,
}

export function TextareaComponent({
  value,
  onValueChange,
  placeholder,
  className,
  alternatives,
  withAlternatives,
  disabled,
  ...restProps
}: TextareaProps) {
  const [isSubmenuState, setSubmenuState] = useAtom(getSubmenuStateAtom);
  const [alternativesNumber, setAlternativesNumber] = useState(alternatives?.length ?? 0);

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onValueChange?.(e.target.value)
  }
  const onOpenAlternatives = () => {
    // INFO: collapse main info window
    setSubmenuState(true);
  }
  const onCloseAlternatives = () => {
    // INFO: expand main info window
    setSubmenuState(false);
  }

  return (
    <div>
      <Textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
        {...restProps}
      />
      {withAlternatives && !!value &&
        <button
          type="button"
          disabled={disabled}
          className="flex items-center text-xs pt-3 text-muted-foreground font-light disabled:cursor-not-allowed disabled:opacity-50"
          onClick={onOpenAlternatives}
        >
          <Icon type="alternatives" />
          {alternativesNumber > 0 ? `${alternativesNumber} alternative messages` : 'Add alternative message'}
        </button>}
      {withAlternatives && !!value && isSubmenuState && !disabled && (
        <AlternativesComponent
          onClose={onCloseAlternatives}
          originalValue={value ?? ''}
          alternativeValues={alternatives ?? []}
          onValuesChange={(values: string[]) => {
            const isAlternativesChanged = values.length && JSON.stringify(values) !== JSON.stringify(alternatives);
            if (isAlternativesChanged) {
              onValueChange?.(value, { alternatives: values });
              setAlternativesNumber(values.length);
            } else if (Array.isArray(values) && !values.length) {
              onValueChange?.(value, { alternatives: [] });
              setAlternativesNumber(0);
            }
          }}
        />
      )}
    </div>
  );
}
